import type { EventLiveRoomStatus } from '@pulsify/shared/dto'

type LiveRoomNotice = { kind: 'one' } | { kind: 'many'; count: number }

/** What the delete dialog warns about: nothing unless people are in the Live Room right now. */
export function liveRoomNotice(status: EventLiveRoomStatus | undefined): LiveRoomNotice | null {
  if (!status || status.closed || status.here <= 0) return null
  return status.here === 1 ? { kind: 'one' } : { kind: 'many', count: status.here }
}
